import type { StrapiUser } from '../../api/strapi';
import { isAdminSampling, isMarketingPic } from '../QuotationsPage/quotationWorkflow';
import { canEditWorkOrder, isAdminWorkOrder } from '../SamplingSchedulesPage/samplingScheduleAccess';

export type WorkOrderListActions = {
  showView: boolean;
  showEdit: boolean;
  showDelete: boolean;
  showKupPdf: boolean;
  showWorkOrderPdf: boolean;
};

function workOrderListPdfOnly(user: StrapiUser | null | undefined): boolean {
  return isMarketingPic(user) || isAdminSampling(user);
}

/** Ikon jadwal di grid work order: admin work order (termasuk pic) dan admin sampling. */
export function canOpenWorkOrderSchedule(user: StrapiUser | null | undefined): boolean {
  return isAdminWorkOrder(user) || isAdminSampling(user);
}

/** Jadwal awal yang terhubung ke work order. Jadwal batal dilewati bila masih ada jadwal lain. */
export function workOrderLinkedScheduleDocumentId(row: {
  sampling_schedules?: Array<{
    documentId?: string;
    schedule_kind?: string | null;
    progress_status?: string | null;
  }> | null;
  sampling_schedule?: {
    documentId?: string;
    schedule_kind?: string | null;
    progress_status?: string | null;
  } | null;
}): string {
  const listed = row.sampling_schedules?.length
    ? row.sampling_schedules
    : row.sampling_schedule
      ? [row.sampling_schedule]
      : [];
  const schedules = listed.filter((schedule) => String(schedule.documentId ?? '').trim());
  const open = schedules.filter((schedule) => String(schedule.progress_status ?? '') !== 'cancelled');
  const pool = open.length ? open : schedules;
  const initial = pool.find((schedule) => (schedule.schedule_kind ?? 'initial') === 'initial');
  return String((initial ?? pool[0])?.documentId ?? '').trim();
}

/** Nomor job WO sudah terbit (admin sampling menyetujui tim). */
export function workOrderJobIssued(row: { job_number?: string | null } | null | undefined): boolean {
  return Boolean(String(row?.job_number ?? '').trim());
}

/**
 * Marketing PIC dan admin sampling hanya boleh membuka PDF work order dari kolom aksi.
 * Tidak ada user type yang boleh menghapus work order, dengan atau tanpa nomor GL.
 */
export function workOrderListActions(
  user: StrapiUser | null | undefined,
  row?: { job_number?: string | null } | null,
): WorkOrderListActions {
  const showWorkOrderPdf = row == null || workOrderJobIssued(row);
  if (workOrderListPdfOnly(user)) {
    return {
      showView: false,
      showEdit: false,
      showDelete: false,
      showKupPdf: false,
      showWorkOrderPdf,
    };
  }
  return {
    showView: true,
    showEdit: canEditWorkOrder(user),
    showDelete: false,
    showKupPdf: true,
    showWorkOrderPdf,
  };
}
